<div ngbDropdown class="cus-notification-mb notification-custom" (openChange)="checkDropDown($event)">
  <div
    aria-haspopup="true"
    class="nav-link dropdown-toggle cursor-pointer user-select-none"
    id="notification-dropdown"
    role="button"
    ngbDropdownToggle
    appKeyboardClickable>
    <i class="material-icons mi-inline">notifications</i>
    @if (totalUnreadNotifications > 0) {
      <span class="notification-count"> {{ totalUnreadNotifications }}</span>
    }
  </div>

  @if (notifications) {
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right dropdown-notification" id="upanel-dropdown1">
      <div class="notifications-list list-group noti-cover">
        @for (notification of notifications; track notification.id) {
          <div>
            <app-agent-notification
              [notification]="notification"
              [totalUnreadNotificationCount]="totalUnreadNotifications"
              (opened)="closeDropdown()" />
          </div>
        }
        @if (notifications.length !== 0) {
          <a
            class="list-group-item list-group-item-action notifications-see-all text-center"
            (click)="showNotificationsModal(notificationsmodal)">
            <span>{{ '$see_all_notifications$' | translate }}</span
            >&nbsp;<span>(</span><span>{{ totalNotifications }}</span
            ><span>)</span>
          </a>
        }
      </div>
    </div>
  }

  @if (notifications && notifications.length === 0) {
    <div
      ngbDropdownMenu
      aria-labelledby="notification-dropdown"
      class="dropdown-menu dropdown-menu-right dropdown-notification">
      <div class="notifications-list list-group noti-cover">
        <div class="no-notification-data text-center mt-3 ml-4 mr-4 pl-4 pr-4">
          <h4 class="mt-2 mb-2">{{ '$no_notifications_yet$' | translate }}</h4>
          <p class="mb-4">{{ '$no_notificiations_body_text$' | translate }}</p>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #notificationsmodal let-modal>
  <app-agent-notifications-overview-modal [modal]="modal" />
</ng-template>
